import m from "../../es2015/themes/moonrisekingdom";
window.am4themes_moonrisekingdom = m;


//////////////////
// WEBPACK FOOTER
// ./themes/moonrisekingdom.js
// module id = null
// module chunks = 